import { K2DigioStatus } from "../types/digio/K2Digio";

export interface DigioStatusMessage {
  title: string;
  description: string;
}

export const DIGIO_STATUS_MESSAGES: Record<K2DigioStatus, DigioStatusMessage> = {
  DO_LATER: {
    title: "Sign later",
    description: "The A2 form has been saved. Please resume signing from the review screen.",
  },
  AWAITING_SIGN: {
    title: "Complete your e-sign",
    description: "Please complete Aadhaar e-sign to proceed with your A2 form.",
  },
  TOKEN_EXPIRED: {
    title: "Session expired",
    description:
      "Your signing session has expired. Tap the button below to refresh and continue with Aadhaar e-sign.",
  },
  LINK_EXPIRED: {
    title: "Link expired",
    description: "This signing link has expired. Please request a new A2 form link from review.",
  },
  SIGNED: {
    title: "E-sign completed",
    description: "Your A2 form has been signed successfully.",
  },
  LINKED: {
    title: "E-sign completed",
    description: "Your A2 form has been signed and linked successfully.",
  },
};
